import { UPDATE_CONFIG } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_CONFIG:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
